import api from '../../../shared/services/api'
import { PROVIDER_COMMENTS_ENDPOINT } from '../../../shared/constants/api-helpers.js'

export const fetchProviderComments = async (physicianId) => {
  const commentResponse = await api.post(PROVIDER_COMMENTS_ENDPOINT, { 'physicianId': physicianId })
  return commentResponse.data
}
